export default __webpack_public_path__ + "static/media/chatCreatorsIcon2.2fe4a1ef.svg";